module.exports = __webpack_public_path__ + "img/ic-correction.633789f0.svg";